// extracted by mini-css-extract-plugin
export var container = "landingPage-module--container--dc5ff";
export var message = "landingPage-module--message--bb42e";
export var messageTop = "landingPage-module--messageTop--81665";